/* eslint-disable no-mixed-spaces-and-tabs */

import './ResultsContainer.scss';

import React from 'react';

import PropTypes from 'prop-types';
import ResultProduct from '../ResultProduct/ResultProduct';
import ResultTerm from '../ResultTerm/ResultTerm';
import cx from 'classnames';
import { decodeHTML } from '../../helpers';
import { useStateValue } from '../../state';

const ResultsContainer = (props) => {
	const {
		getMenuProps,
		highlightedIndex,
		getItemProps,
		isOpen,
		searchResults,
		inputValue,
	} = props;

	const [{ _t }] = useStateValue();


	const isTabletPlus = () => {
		if (!window) return true;
		return window.innerWidth > 767;
	};

	const containerStyle = () => {
		  
			let widthDifference;
			window.innerWidth > 989
				? (widthDifference = 8.5)
				: (widthDifference = 3.5);

			// close button width + left padding
			return {
				width: `calc(100% - ${widthDifference}rem)`,
				minWidth: 'auto',
			};
		
	};

	return (
		<div
			data-testid="siteSearch-results-container"
			className={cx(
				'siteSearch__results-container',
				'box-border',
				'rounded-t-none',
				'lg:left-0',
				'-mt-px',
				'right-0',
				'border',
				'border-t-0',
				'',
				'border-solid',
				'ml-2 lg:ml-6 border-gray-30',
				isOpen && searchResults && searchResults.length
					? 'border-b'
					: 'border-b-0',
				{
					'aol-w-calc': props.clientCode !== 'ADE',
					'ade-w-calc': props.clientCode === 'ADE',
				}
			)}
			style={containerStyle()}
			{...getMenuProps()}>
			<ul
				data-testid="siteSearch-popular-searches"
				className="siteSearch__results-list">
				{isOpen &&
				searchResults.filter(
					(x) => x.PredictiveSearchType === 'PopularSearches'
				).length > 0 ? (
					<li
						key="title"
						data-testid="siteSearch-popular-searches-title-item"
						className="siteSearch__products-title-item px-4">
						<strong className="search-term">{_t.popularSearchLabel}</strong>
					</li>
				) : null}
				{isOpen && searchResults.length
					? searchResults
							.filter((x) => x.PredictiveSearchType === 'PopularSearches')
							.map((result, index) => {
								return (
									<ResultTerm
										key={`${result.PredictiveSearchType.toLowerCase()}-${index}`}
										term={result.Title}
										index={index}
										itemProps={getItemProps({ item: result, index })}
										isHighlighted={highlightedIndex === index ? true : false}
										inputValue={inputValue}
									/>
								);
							})
					: null}
			</ul>
			<ul
				data-testid="siteSearch-predictive-results"
				className={cx(
					'siteSearch__results-list',
					isOpen && inputValue !== ''
						? 'border-0 border-t border-solid border-gray-40'
						: '',
					searchResults && !searchResults.length ? 'hidden' : ''
				)}>
				{isOpen && searchResults.length
					? searchResults
							.filter((x) => x.PredictiveSearchType === 'Keyword')
							.map((result, index) => {
								return (
									<ResultTerm
										key={`${result.PredictiveSearchType.toLowerCase()}-${index}`}
										term={result.Title}
										index={index}
										itemProps={getItemProps({ item: result, index })}
										isHighlighted={highlightedIndex === index ? true : false}
										inputValue={inputValue}
									/>
								);
							})
					: null}

				{isOpen &&
				isTabletPlus &&
				searchResults.length &&
				searchResults.filter(
					(result) => result.PredictiveSearchType === 'Product'
				).length ? (
					<li
						key="title"
						data-testid="siteSearch-most-popular"
						className="siteSearch__products-title-item px-4">
						{_t.productListLabel}{' '}
						<strong className="search-term">{inputValue}</strong>
					</li>
				) : null}

				{isOpen && isTabletPlus && searchResults.length
					? searchResults.map((result, index) => {
							if (result.PredictiveSearchType === 'Product') {
								return (
									<ResultProduct
										key={`${result.PredictiveSearchType.toLowerCase()}-${index}`}
										image={result.ImageUrl}
										shortTitle={result.Title}
										price={decodeHTML(result.DisplayPrice)}
										isTopFive={result.IsTopFive}
										index={index}
										itemProps={getItemProps({ item: result, index })}
										isHighlighted={highlightedIndex === index ? true : false}
										inputValue={inputValue}
									/>
								);
							}
					  })
					: null}
			</ul>
		</div>
	);
};

ResultsContainer.propTypes = {
	getMenuProps: PropTypes.func,
	highlightedIndex: PropTypes.any,
	getItemProps: PropTypes.func,
	isOpen: PropTypes.bool,
	searchResults: PropTypes.array,
	inputValue: PropTypes.string,
	clientCode: PropTypes.string,
};

export default ResultsContainer;
